export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "product/list",
            name: "productList",
            component: resolve => require(["@/modules/product/pages/list.vue"], resolve),
            meta: {
              nameText: "产品列表",
            },
          },
          {
            path: "product/edit/:id",
            name: "productEdit",
            component: resolve => require(["@/modules/product/pages/edit.vue"], resolve),
            meta: {
              nameText: "创建产品",
            },
          },
          {
            path: "product/report/:id",
            name: "productReport",
            component: resolve => require(["@/modules/product/pages/report.vue"], resolve),
            meta: {
              nameText: "产品统计",
            },
          },
          {
            path: "product/listall",
            name: "productListAll",
            component: resolve => require(["@/modules/product/pages/listAll.vue"], resolve),
            meta: {
              nameText: "公共产品池",
            },
          },
          {
            path: "product/type",
            name: "productType",
            component: resolve => require(["@/modules/product/pages/type.vue"], resolve),
            meta: {
              nameText: "产品分类",
            },
          },
          {
            path: "product/subject",
            name: "productSubject",
            component: resolve => require(["@/modules/product/pages/subject.vue"], resolve),
            meta: {
              nameText: "产品专题",
            },
          },
          {
            path: "product/subject/edit",
            name: "productSubjectEdit",
            component: resolve => require(["@/modules/product/pages/subjectEdit.vue"], resolve),
            meta: {
              nameText: "编辑专题",
            },
          },
        ],
      },
    ],
  }
];
